const oktaConfig = {
  url: 'https://signin.syngenta.com/',
  clientId: '0oaam7j573HHZUQbL4x7',
  authId: 'SSWS 00_3DhEqjsQPflFznjfo_qU-kMoJXD-U-TNQI8ZF9z',
};

export default oktaConfig;